// Non-breaking space is to ensure phone number wraps properly when used in translation.
export const formatPhoneNumberWithNonBreakingSpace = (phoneNumber: string | undefined) => {
  if (phoneNumber === undefined) return '';
  if (phoneNumber.length <= 6) return phoneNumber;
  return `(***)\u00a0***-${phoneNumber.slice(6)}`;
};
